const FETCH_LOAN_INFO_START = 'FETCH_LOAN_INFO_START'
const FETCH_LOAN_INFO_SUCCESS = 'FETCH_LOAN_INFO_SUCCESS'
const FETCH_LOAN_INFO_FAILURE = 'FETCH_LOAN_INFO_FAILURE'

const loanInfoStart = () => {
    return {
        type: FETCH_LOAN_INFO_START
    }
}

const loanInfoSuccess = (loanInfo) => {
    return {
        type: FETCH_LOAN_INFO_SUCCESS,
        payload: loanInfo
    }
}

const loanInfoError = ({message}) => {
    return {
        type: FETCH_LOAN_INFO_FAILURE,
        payload: message
    }
}


const fetchLoanInfo = (loanService, dispatch) => (accessToken) => {
    dispatch(loanInfoStart())
    loanService.loanInfo(accessToken)
        .then((data) => {
            dispatch(loanInfoSuccess(data))
        })
        .catch((err) => dispatch(loanInfoError(err)));
}

export {
    FETCH_LOAN_INFO_START,
    FETCH_LOAN_INFO_SUCCESS,
    FETCH_LOAN_INFO_FAILURE,
    fetchLoanInfo,
}
